import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TSwissPostConnectedEmsResponsePayload,
	TSwissPostStore,
	TSwissPostAvailableEmsResponsePayload,
} from './types';

// ==========================================:
const getSwissPostState = (state: TStoreState): TSwissPostStore => state.swissPost;
export const getSwissPost = createSelector(
	[getSwissPostState],
	(swissPost: TSwissPostStore) => swissPost,
);

// ====================================================:
export const getSwissPostConnectedEmsIsLoad = createSelector(
	[getSwissPost],
	(swissPost: TSwissPostStore): boolean => swissPost.swissPostConnectedEmsLoader,
);

// ====================================================:
export const getSwissPostConnectedEms = createSelector(
	[getSwissPost],
	(swissPost: TSwissPostStore): TSwissPostConnectedEmsResponsePayload =>
		swissPost.swissPostConnectedEms,
);

// ====================================================:

export const getSwissPostAvailableEmsIsLoad = createSelector(
	[getSwissPost],
	(swissPost: TSwissPostStore): boolean => swissPost.swissPostAvailableEmsLoader,
);

// ====================================================:

export const getSwissPostAvailableEms = createSelector(
	[getSwissPost],
	(swissPost: TSwissPostStore): TSwissPostAvailableEmsResponsePayload =>
		swissPost.swissPostAvailableEms,
);
